import Chart from 'components/charts/Echart';

const PieChart = ({
  chartData,
  chartType,
  legend,
  chartAllData,
  screenType,
}) => {
  return (
    <Chart
      chartData={chartData}
      chartType={chartType}
      radius='45%'
      center={['50%', '27%']}
      legend={legend}
      isMultiChart={true}
      style={{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      }}
      chartAllData={chartAllData}
      screenType={screenType}
    />
  );
};

export default PieChart;
